import React from 'react'

const LiquidityIcon = ({ width = 14, height = 14, fillcolor = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3.1L7.05025 8.05025C4.31658 10.7839 4.31658 15.2161 7.05025 17.9497C9.78392 20.6834 14.2161 20.6834 16.9497 17.9497C19.6834 15.2161 19.6834 10.7839 16.9497 8.05025L12 3.1ZM12 5.92548L15.5355 9.46447C17.4882 11.4171 17.4882 14.5829 15.5355 16.5355C13.5829 18.4882 10.4171 18.4882 8.46447 16.5355C6.51184 14.5829 6.51184 11.4171 8.46447 9.46447L12 5.92548Z"
        fill={fillcolor}
      />
    </svg>
  )
}

export default LiquidityIcon
